import React from 'react';
import styles from './HorizontalRule.css';

const HorizontalRule = () => <div className={styles.line} />;

export default HorizontalRule;



// WEBPACK FOOTER //
// ./src/components/HorizontalRule.jsx